import React, { useRef, useEffect, useState } from 'react'
import QRCodeStyling from 'qr-code-styling'
import { useForm } from '../Hooks/useForm'
import Button from '../Button/Button'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(
  {
    container: {
      display: 'inline-block',
      textAlign: 'center'
    }
  },
  { name: 'bund-' }
)

const qrCode = new QRCodeStyling({
  qrOptions: {
    typeNumber: '0',
    mode: 'Byte',
    errorCorrectionLevel: 'Q'
  }
})

export const QR = (props) => {
  const {
    style,
    width,
    height,
    type,
    image,
    dotsColor,
    dotsType,
    cornerSqureType,
    cornerSquareColor,
    cornerDotType,
    cornerDotColor,
    margin,
    href,
    imageMargin,
    download,
    ext,
    background
  } = props
  const ref = useRef(null)
  useEffect(() => {
    qrCode.append(ref.current)
  }, [])
  useEffect(() => {
    qrCode.update({
      type: type,
      width: width,
      height: height,
      dotsOptions: {
        color: dotsColor,
        type: dotsType
      },
      backgroundOptions: { color: background },
      cornersSquareOptions: { type: cornerSqureType, color: cornerSquareColor },
      cornersDotOptions: { type: cornerDotType, color: cornerDotColor },
      data: href,
      image: image,
      margin: margin,
      imageOptions: {
        margin: imageMargin
      }
    })
  }, [
    href,
    type,
    margin,
    imageMargin,
    dotsType,
    dotsColor,
    image,
    width,
    height,
    cornerSqureType,
    cornerSquareColor,
    cornerDotType,
    cornerDotColor,
    background
  ])

  const onDownloadClick = () => {
    qrCode.download({
      extension: ext
    })
  }

  const classes = useStyles()

  return (
    <div style={style} className={clsx(classes.container)}>
      <div
        ref={ref}
        style={{
          borderRadius: '8px'
        }}
      />
      {download ? (
        <Button
          color="primary"
          shape="round"
          size="sm"
          onClick={onDownloadClick}
          variant="outline">
          Download
        </Button>
      ) : (
        ''
      )}
    </div>
  )
}

QR.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  image: PropTypes.string,
  type: PropTypes.oneOf(['canvas', 'svg']),
  dotsColor: PropTypes.string,

  dotsType: PropTypes.oneOf([
    'extra-rounded',
    'rounded',
    'dots',
    'square',
    'classy',
    'classy-rounded'
  ]),
  cornerSquareColor: PropTypes.string,
  cornerSqureType: PropTypes.oneOf(['dot', 'square', 'extra-rounded']),
  cornerDotType: PropTypes.oneOf(['dot', 'square']),
  cornerDotColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  margin: PropTypes.number,
  imageMargin: PropTypes.number,
  download: PropTypes.bool,
  background: PropTypes.string,
  /**
   * The url to generate qr code for.
   */

  href: PropTypes.string,

  /**
   * Extension for generated qr code.
   */

  ext: PropTypes.oneOf(['png', 'jpeg', 'webp', 'svg'])
}

QR.defaultProps = {
  ext: 'png',
  type: 'canvas',
  margin: 0,
  imageMargin: 6,
  width: 182,
  height: 182,
  dotsColor: '#000',
  dotsType: 'dots',
  cornerSqureType: 'extra-rounded',
  cornerSquareColor: '#000',
  cornerDotType: 'dot',
  cornerDotColor: '#000',
  background: '#ffffff',
  image: '/imgs/svg/icons/bu-beyound_v16.svg'
}

QR.displayName = 'qr'

export default QR
